// extracted by mini-css-extract-plugin
export default {"Button":"styles_Button__yRvau"};